<script setup lang="ts">
const props = defineProps<{
  disabled?: boolean
  viewOnly?: boolean
  setScoreAndSubmit: (score: number) => void
  remainingScoreForCurrentPlayer: number
}>()

const shortCuts = computed(() => {
  const baseList = [45, 57, 60, 85, 100, 140]
  if (props.remainingScoreForCurrentPlayer > 180) {
    baseList.push(180)
  }
  return baseList
})
</script>

<template>
  <div
    v-if="!disabled && !viewOnly"
    class="hidden sm:grid gap-0.5 grid-cols-8 w-full h-12 md:h-18"
    :class="{ 'pointer-events-none': disabled, 'touch-none': disabled }"
  >
    <button
      v-if="remainingScoreForCurrentPlayer < 180"
      v-touch:tap.prevent="() => setScoreAndSubmit(0)"
      class="!text-md !font-bold bg-warning text-warning-foreground !cursor-pointer rounded-md"
    >
      Bust
    </button>
    <button
      v-for="(shortcut) in shortCuts"
      :key="`shortcut${shortcut}`"
      v-touch:tap.prevent="() => !(remainingScoreForCurrentPlayer <= (shortcut + 1) && remainingScoreForCurrentPlayer !== shortcut) && setScoreAndSubmit(shortcut)"
      class="md:!text-2xl bg-primary text-primary-foreground rounded-md !cursor-pointer"
      :class="{ '!opacity-20': remainingScoreForCurrentPlayer <= (shortcut + 1) && remainingScoreForCurrentPlayer !== shortcut }"
    >
      {{ shortcut }}
    </button>
    <button
      v-if="remainingScoreForCurrentPlayer < 170 && ![169, 168, 166, 165, 163, 162, 159].includes(remainingScoreForCurrentPlayer)"
      v-touch:tap.prevent="() => setScoreAndSubmit(remainingScoreForCurrentPlayer)"
      class="!text-md font-bold bg-green-500 text-positive-foreground !cursor-pointer rounded-md"
    >
      Shot {{ remainingScoreForCurrentPlayer }}
    </button>
  </div>
</template>

<style scoped>

</style>
